module.exports = __webpack_public_path__ + "img/feature.621a9175.webp";